import {createTheme} from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface Theme {
    status: {
      danger: string;
    };
  }

  interface ThemeOptions {
    status?: {
      danger?: string;
    };
  }
  interface Palette {
    customColors?: {
      onlineCardBackground?: string;
      switchChecked?: string;
      switchUnchecked?: string;
      trackDark?: string;
      trackLight?: string;
      responsiveAppBarSettings?: string;
      contrastPrimary?: string;
      overviewStars?: string;
      urlLink?: string;
      urlLinkLight?: string;
      messageFont?: string;
      messageFontOwn?: string;
      messageFontSender?: string;
      messageFontSenderOwn?: string;
      messageBackground?: string;
      messageBackgroundOwn?: string;
      messageText?: string;
      messageTextOwn?: string;
    };
  }
  interface PaletteOptions {
    customColors?: {
      onlineCardBackground?: string;
      switchChecked?: string;
      switchUnchecked?: string;
      trackDark?: string;
      trackLight?: string;
      responsiveAppBarSettings?: string;
      contrastPrimary?: string;
      overviewStars?: string;
      urlLink?: string;
      urlLinkLight?: string;
      messageFont?: string;
      messageFontOwn?: string;
      messageFontSender?: string;
      messageFontSenderOwn?: string;
      messageBackground?: string;
      messageBackgroundOwn?: string;
      messageText?: string;
      messageTextOwn?: string;
    };
  }
}

const sharedTheme = {
  typography: {
    fontFamily: 'Roboto, sans-serif'
  },

  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920
    }
  }

  //  spacing: ['8px','16px','24px' ...],
};

export const lightTheme = createTheme({
  ...sharedTheme,
  palette: {
    mode: 'light',
    primary: {
      main: '#EB5757',
      light: '#FF8282',
      dark: '#D33232',
      contrastText: '#F6F6F6'
    },
    secondary: {
      main: '#00838F',
      light: '#4FB3BF',
      dark: '#005662',
      contrastText: '#F6F6F6'
    },
    customColors: {
      onlineCardBackground: '#707070',
      switchChecked: '#003892',
      switchUnchecked: '#A38400',
      trackDark: '#8796A5',
      trackLight: '#aab4be',
      responsiveAppBarSettings: '#EEEEEE',
      messageFont: '#606060',
      messageFontOwn: '#505050',
      messageFontSender: '#050505',
      messageFontSenderOwn: '#F6F6F6',
      messageBackground: 'rgb(227, 221, 235)',
      messageBackgroundOwn: '#EB5757',
      messageText: '#F6F6F6',
      messageTextOwn: 'rgb(73, 69, 79, 1)',
      urlLink: '#005662',
      urlLinkLight: '#00FFFF'
    },
    background: {
      default: '#EEEEEE',
      paper: '#F6F6F6'
    },
    text: {
      primary: '#222222',
      secondary: '#222222',
      disabled: '#666666'
    }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5'
        }
      }
    },
    // MuiMenu: {
    //   styleOverrides: {
    //     paper: {
    //       minWidth: '60% !important'
    //     }
    //   }
    // },
    MuiFormControl: {
      styleOverrides: {
        root: {
          backgroundColor: '#f5f5f5'
        }
      }
    }
  }
  //  secondary: { main: '#d42100', dark: '#d42100', light: '#d42100' },

  //  spacing: ['8px','16px','24px' ...],
  // typography: {
  //   fontFamily: 'Titillium Web, sans-serif',
  // },
  // components: {
  //   MuiButton: {
  //     defaultProps: {
  //       variant: 'contained',
  //       color: 'secondary',
  //     },
  //   },
  // },
});

export const darkTheme = createTheme({
  ...sharedTheme,
  palette: {
    mode: 'dark',
    secondary: {
      main: '#EB5757',
      light: '#FF8282',
      dark: '#D33232',
      contrastText: '#F4F4F4'
    },
    primary: {
      main: '#00838F',
      light: '#4FB3BF',
      dark: '#005662',
      contrastText: '#F4F4F4'
    },

    customColors: {
      onlineCardBackground: '#707070',
      switchChecked: '#003892',
      switchUnchecked: '#A38400',
      trackDark: '#8796A5',
      trackLight: '#aab4be',
      responsiveAppBarSettings: '#EEEEEE',
      messageFont: '#505050',
      messageFontOwn: '#505050',
      messageFontSender: '#505050',
      messageFontSenderOwn: '#505050',
      messageBackground: 'rgb(213, 207, 221)',
      messageBackgroundOwn: '#D33232',
      messageText: '#FFFFFF',
      messageTextOwn: 'rgb(53, 49, 59, 1)',
      urlLink: '#FFA500',
      urlLinkLight: '#FFA500'
    },

    background: {
      default: '#050505',
      paper: '#242424'
    },

    text: {
      primary: '#F4F4F4',
      secondary: '#F4F4F4',
      disabled: '#666666'
    }
  },
  components: {
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundColor: '#303030'
        }
      }
    },
    // MuiMenu: {
    //   styleOverrides: {
    //     paper: {
    //       minWidth: '30% !important'
    //     }
    //   }
    // },

    MuiFormControl: {
      styleOverrides: {
        root: {
          backgroundColor: '#303030'
        }
      }
    }
  }
});
